import { RouteComponentProps } from '@reach/router';
import { Card, CardBody } from 'components/atoms/card';
import { H3, Paragraph } from 'components/atoms/text';
import { useHeader } from 'contexts/headerContext';
import { AgreementType, SendAgreementTaskMailInputModel } from 'hooks/agreement/types';
import useAgreements from 'hooks/agreement/';
import { FormGroup, FormikFormFile, FormikFormTextarea } from 'components/atoms/form';
import { Form, Formik, FormikHelpers } from 'formik';
import { toFormikErrors } from 'utils/errorhelper';
import { toast } from 'react-toastify';
import { Button } from 'components/atoms/button';
import React, { FC } from 'react';

interface ReviewProps extends RouteComponentProps { }

const initialValues: SendAgreementTaskMailInputModel = {
    file: undefined,
    comments: '',
    type: AgreementType.Update
};

const CaUpdate: FC<ReviewProps> = () => {
    useHeader('Overeenkomsten');

    const { sendAgreementTaskMail } = useAgreements();

    const handleMail = async (values: SendAgreementTaskMailInputModel, { setErrors, resetForm }: FormikHelpers<SendAgreementTaskMailInputModel>) => {
        const response = await sendAgreementTaskMail(values);

        if (response.ok) {
            toast.success('Uw aanvraag voor het updaten van de Overeenkomst is succesvol verstuurd');
            resetForm();
        } else if (response.errors) {
            const errors = toFormikErrors<SendAgreementTaskMailInputModel>(response.errors);
            setErrors(errors);
        } else {
            toast.error('Er ging iets fout bij het versturen van de update-aanvraag');
        }
    };

    return (
        <>
            <Card variant="primary">
                <CardBody>
                    <H3 variant="white">Update overeenkomsten</H3>
                    <Paragraph variant="white">
                        Twijfelt u over de actualiteit van uw overeenkomst of hebben zich sindsdien wijzigingen voorgedaan in uw bedrijfsactiviteiten?
                    </Paragraph>
                    <Paragraph variant="white" noMargin>
                        Vul onderstaande formulier in en wij nemen contact met u op voor een beoordeling van uw overeenkomst.
                    </Paragraph>
                </CardBody>
            </Card>
            <Card>
                <CardBody>
                    <Formik<SendAgreementTaskMailInputModel> initialValues={initialValues} onSubmit={handleMail}>
                        {({ isSubmitting }) => (
                            <Form>
                                <FormGroup label="Bijlage toevoegen" required>
                                    <FormikFormFile name="file" />
                                </FormGroup>
                                <FormGroup label="Vraag of opmerking">
                                    <FormikFormTextarea name="comments" placeholder="Opmerking" />
                                </FormGroup>
                                <FormGroup noMargin alignRight>
                                    <Button loading={isSubmitting}>Verzenden</Button>
                                </FormGroup>
                            </Form>
                        )}
                    </Formik>
                </CardBody>
            </Card>
        </>
    );
};

export default CaUpdate;
